export const MARKETING_URL =
  (import.meta.env.VITE_MARKETING_URL as string | undefined)?.replace(/\/$/, '') ||
  'https://xplorit.io';

export function marketingUrl(path: string = ''): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${MARKETING_URL}${p === '/' ? '' : p}`;
}
